import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Scale } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-4">
          <Scale className="h-8 w-8 text-slate-900 animate-pulse" />
          <p className="text-sm text-slate-500 tracking-widest uppercase">Chargement</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}
